import i18next from 'i18next'

import { ValidateFormService } from 'services/ValidateFormService'
import { EmployeeKeys, MIN_NAME_LENGTH } from 'sections/LKSection/modules/EmployeeModule/data'
import { ViewEmployeeUiStore } from 'sections/LKSection/modules/EmployeeModule/stores/ViewEmployeeUiStore'
import { getSnilsError } from 'sections/LKSection/modules/UserModule/utils/getSnilsError'

const getKey = (key: string) => `${EmployeeKeys.addEmployeePage}.validate.${key}`

export class ValidateAddEmployee extends ValidateFormService {
  validate = (uiStore: ViewEmployeeUiStore) => {
    const errors: string[] = []
    const snilsError = getSnilsError(uiStore.snils)

    if (!uiStore.lastName) {
      errors.push(i18next.t(getKey('lastNameError')))
    } else {
      if (uiStore.lastName.trim().length < MIN_NAME_LENGTH) {
        errors.push(i18next.t(getKey('lastNameMinLengthError'), { count: MIN_NAME_LENGTH }))
      }
    }

    if (!uiStore.firstName) {
      errors.push(i18next.t(getKey('firstNameError')))
    } else {
      if (uiStore.firstName.trim().length < MIN_NAME_LENGTH) {
        errors.push(i18next.t(getKey('firstNameMinLengthError'), { count: MIN_NAME_LENGTH }))
      }
    }

    if (uiStore.snils && snilsError) {
      errors.push(snilsError)
    }

    if (!uiStore.phoneModel.fullPhone) {
      errors.push(i18next.t(getKey('fullPhoneError')))
    } else {
      if (!uiStore.phoneModel.isValidPhone) {
        errors.push(i18next.t(getKey('fullPhoneValidError')))
      }
    }

    return this.hasNotErrors(errors)
  }
}

export const validateAddEmployee = new ValidateAddEmployee()
